var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.200195,
    width: 30,
    height: 30,
    rx: 8,
    fill: "#0065FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6806 22.5H11.7206C10.9625 22.4724 10.2563 22.1078 9.79489 21.5056C9.33348 20.9035 9.16506 20.1267 9.33563 19.3875L9.51563 18.5325C9.72266 17.3751 10.7176 16.5245 11.8931 16.5H18.5081C19.6837 16.5245 20.6786 17.3751 20.8856 18.5325L21.0656 19.3875C21.2362 20.1267 21.0678 20.9035 20.6064 21.5056C20.145 22.1078 19.4388 22.4724 18.6806 22.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5756 15H14.8256C13.1688 15 11.8256 13.6569 11.8256 12V10.02C11.8236 9.35105 12.0885 8.70892 12.5615 8.23589C13.0345 7.76287 13.6767 7.49801 14.3456 7.50001H16.0556C16.7246 7.49801 17.3667 7.76287 17.8398 8.23589C18.3128 8.70892 18.5776 9.35105 18.5756 10.02V12C18.5756 12.7957 18.2596 13.5587 17.697 14.1213C17.1343 14.6839 16.3713 15 15.5756 15Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewUserIcon);
export default __webpack_public_path__ + "static/media/newUserIcon.104160d90d8723d45dfdcd8ec6e97d10.svg";
export { ForwardRef as ReactComponent };